import { render, staticRenderFns } from "./PendingRequests.vue?vue&type=template&id=0d52534c"
import script from "./PendingRequests.vue?vue&type=script&lang=js"
export * from "./PendingRequests.vue?vue&type=script&lang=js"
import style0 from "./PendingRequests.vue?vue&type=style&index=0&id=0d52534c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports